import { acceptNumberValue } from '../../field-viewer/shared-normalizers';
export const challengesNumberViewer = {
    normalizeLoadedValue: acceptNumberValue
};

//# sourceMappingURL=definition-viewer.js.map